module.exports = __webpack_public_path__ + "img/desc-img.76fe3d86.png";